const composerPath = '/bet-share/composer/'

declare const __APP_REMOTE_DOMAIN__: string | undefined

export const getBaseUrl = (): string => {
	const envDomain = (typeof __APP_REMOTE_DOMAIN__ !== 'undefined' ? __APP_REMOTE_DOMAIN__ : import.meta.env.VITE_REMOTE_DOMAIN || '').trim()
	const origin = window.location.origin

	let url: string

	if (envDomain && (origin.startsWith('capacitor://') || origin.includes('localhost'))) {
		if (/dev\d+\./.test(envDomain)) {
			url = envDomain.replace(/\/$/, '') + composerPath
		} else {
			url = envDomain
		}
	} else if (!envDomain) {
		url = origin + window.location.pathname
	} else {
		if (/dev\d+\./.test(envDomain)) {
			url = envDomain.replace(/\/$/, '') + composerPath
		} else {
			url = envDomain
		}
	}

	if (!url.endsWith('/')) {
		url += '/'
	}

	return url
}

export const translateShareUrl = (originalUrl: string): string => {
	if (!originalUrl) return originalUrl

	const isDev = /dev.*\.springonion\.net/.test(originalUrl)
	if (isDev) {
		console.log("**** translateShareUrl starting remapping for: " + originalUrl)

		let remapped = originalUrl.replace('/bet-share/composer/s/', '/s/')

		if (remapped === originalUrl) {
			remapped = originalUrl.replace('/bet-share/composer/', '/')
		}

		remapped = remapped.replace(/([^:])\/\//g, '$1/')

		if (remapped !== originalUrl) {
			console.log("**** translateShareUrl SUCCESS: " + remapped)
			return remapped
		} else {
			console.log("**** translateShareUrl NO CHANGE applied")
		}
	}

	return originalUrl
}